/**
 * /pages/Content.js – Работа со всеми контент страницами — FAQ, Алгоритмы, Акции, Скрипты, Документы, 
 * 		Новости, Инструкции, Тарифы курьеров
 * /stores/content.js – Хранилище для работы с контетом
 * 
 * Контент страницы бывают 4 типов
 * — Обычные текстовые страницы — право для редактирования «ManageContent»
 * – Маркетинговые страницы «Акций» — право для редактирования «ManageStock»
 * — Документы с возможностью печати — право для редактирования «ManageContent»
 * — Новостные разделы «Новости» — право для редактирования «ManageNews» (не запущено в бой)
 * 
 * Пользователь с правами видит все группы статей и статьи раздела по запросу «GetContent» 
 * 		с указанием ID рабочего стола, к которому привязаны статьи
 * 
 * Пользователь без прав видит только активные статьи, доступные ему либо по филиалу (все),
 * 		либо по должности (новости)
 * 
 * Для справочников вызываются следующие методы один раз при загрузке страницы
 *  - «Roles» — список должностей предприятия для ограничения доступа к новостям
 *  - «Filials» — список филиалов предприятия для ограничения доступа к всем страницам
 *  - «Brands» — список брендов по предприятию для привязки Акций к бренду
 * 
 * Для редактирования названия группы статей, а так же для изменения порядка статей в группе используется
 * 		метод «ChangeOrderContent» с названием группы и перечнем ID статей в нужном порядке
 * 
 * Для изменения порядка групп статей используется метод «GroupOrder» со списком ID групп в нужном порядке
 * 
 * Для изменения тела статьи используется метод «SaveContent»
 * Изменение активности статьи происходит по методу «ChangeStateContent» с указанием ID статьи
 * Удаление статьи происходит по методу «RemoveContent» с указанием ID статьи
 */

import React, { Component } from 'react';
import { observer } from "mobx-react";
import { autorun } from 'mobx';
import _ from 'lodash';
import cookie from 'react-cookies';

import Parser from 'html-react-parser';
import ReactToPrint from 'react-to-print';

import { ContentState, contentState } from '../stores/content';
import { ContentApi, FilialApi, RoleApi, SystemApi } from '../stores/apiMethods';
import { authUserState, uistate, confirmState } from '../stores/common';

import { AddButton, AddIconButton, EditIconButton, PrintIconButton, RemoveIconButton, VisibilityIconButton } from '../shared/PageComponents';
import { EmptyResultInformer, FormModal, InlineError } from '../shared/FeedbackComponents';
import { TextInput, Selectize, TextEditor, SubmitButton, CheckFilter, SelectGroupInput } from '../forms/FormItems';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import { NavLink } from 'react-router-dom';

import { toSelectList, formatDate } from '../functions';

// TODO: заменить локальный SortableHandle на общий элемент с SortIcon.
const DragHandle = SortableHandle(() => <i className="SortHandle"></i>);

export class ContentPage extends Component {
	constructor(props) {
		super(props);

		this.store = new ContentState(authUserState.DashboardId, props.Type);
		this.disposer = autorun(() => {
			const dashboardId = authUserState.DashboardId;

			if (_.indexOf(this.store.ContentPageIds, dashboardId) !== -1) {
				this.store.DashboardId = dashboardId;
				this.getData();
			}
		});
	}

	componentDidMount() {
		RoleApi.getList(false, (data) => {
			this.store.Roles = data.Success && !_.isNull(data.Roles) ? data.Roles : [];
		});
		FilialApi.getList((data) => {
			this.store.Filials = data.Success && !_.isNull(data.Filials) ? data.Filials : [];
		});
		SystemApi.getBrands((data) => {
			this.store.Brands = data.Success && !_.isNull(data.Brands) ? data.Brands : [];
		});
	}

	componentDidUpdate(prevProps) {
		if (prevProps.Type !== this.props.Type) this.store.Type = this.props.Type;
	}

	componentWillUnmount() { this.disposer(); }

	/**
	 * API запрос «GetContent» на получение контента для текущего дашборда.
	 * Переданный ID статьи используется для её повторного открытия после обновления списка,
	 * например после успешного сохранения; без ID открывается статья по умолчанию.
	 * @param {number} id ID статьи, которую необходимо открыть после загрузки
	 */
	getData(id) {
		this.store.IsSendRequest = false;
		ContentApi.getList(this.store.DashboardId, (data) => { this.store.setContent(data, id, false); });
	}

	render() {
		return (
			<div className={"page " + (uistate.IsMobile ? "mobile" : "")} id="ContentPage">
				<div className="head">
					<h2>{this.store.PageTitle}</h2>
					{!this.store.isNews &&
						<form className={"searchBlock"}>
							<TextInput 
								Id="SearchString" 
								Icon="search" 
								Title="Поиск по странице"
								RowClass="nomargin"
								onChange={(value, id) => this.store.Glossary.collect(id, value)}
							/>
						</form>
					}
				</div>
				{this.store.IsSendRequest &&
					<section className={this.store.ContentType}>
						<PageContentListBlock getData={this.getData.bind(this)} store={this.store} />
						{!_.isUndefined(this.store.Glossary) && !_.isUndefined(this.store.Glossary.Article) &&
							<ArticleBlock
								Article={this.store.Glossary.Article}
								CanManage={this.store.CanManage}
								Filials={this.store.Filials}
								Roles={this.store.Roles}
								Brands={this.store.Brands}
								clearEmptyArticle={() => this.store.Glossary.clearEmptyArticleFromGroup()}
								getData={this.getData.bind(this)}
							/>
						}
						{!_.isUndefined(this.store.Glossary) && !_.isUndefined(this.store.Glossary.Group) &&
							<GroupNameBlock
								Group={this.store.Glossary.Group}
								addGroupToList={() => this.store.Glossary.addGroupToList()}
								onClose={() => { this.store.Glossary.Group = undefined; }}
								getData={this.getData.bind(this)}
							/>
						}
					</section>
				}
			</div>
		)
	}
}
ContentPage = observer(ContentPage);

class PageContentListBlock extends Component {
	/** Добавление новой статьи в раздел */
	addArticle(id) { this.props.store.Glossary.addArticleToGroup(id); }

	/** Окно изменения названия раздела */
	changeGroup(id) { this.props.store.Glossary.setGroup(id); }

	/**
	 * API запрос «GroupOrder» для изменения порядка групп
	 * @param {object} sortParams параметры сортировочной функции
	 */
	changeOrderGroup(sortParams) {
		ContentApi.saveGroupOrder(this.props.store.Glossary.changeOrderGroups(sortParams), () => {
			this.props.getData(); 
		});
	}

	render() {
		var isEdit = this.props.store.Glossary.Article && this.props.store.Glossary.Article.EditMode,
			SortableItem = SortableElement(({item, sortIndex}) => {
				return(
					<div className='group' key={item.Id} index={sortIndex}>
						{this.props.store.CanManage && !this.props.store.isNews && !uistate.IsMobile && !isEdit && <DragHandle />}
						<h5>
							{item.Name}
							{this.props.store.CanManage && !isEdit && !uistate.IsMobile &&
								<span className='actions'>
									{!this.props.store.isNews &&
										<EditIconButton Title="Редактировать название раздела"
											onClick={() => this.changeGroup(item.Id)} />
									}
									<AddIconButton onClick={() => this.addArticle(item.Id)} />
								</span>
							}
						</h5>
					<PageContentListItem Pages={item.Pages} getData={this.props.getData}
						GroupId={item.Id} store={this.props.store} />
					</div>
				)
			}),
			SortableList = SortableContainer(({items}) => {
				return (
					<div className="SortableList">{items.map((value, index) => (
						<SortableItem key={"ag" + index} index={index} item={value} sortIndex={index} />
					))}</div>
				);
			});
		
		return(
			<div className='glossary'>
				{this.props.store.Glossary.SearchString !== "" && _.isEmpty(this.props.store.Glossary.Pages) &&
					<EmptyResultInformer />
				}
				{uistate.isDevice &&
					<form>
						<SelectGroupInput
							Id="Pages"
							Title="Статьи"
							Type="number"
							List={this.props.store.Glossary.MobilePages}
							onChange={(value) => this.props.store.Glossary.setArticle(value)}
						/>
					</form>
				}
				{!uistate.isDevice &&
					<SortableList 
						items={this.props.store.Glossary.Pages}
						onSortEnd={(sortParams) => this.changeOrderGroup(sortParams)}
						useDragHandle   
						helperClass="SortableHelper"
						axis="xy"
						lockToContainerEdges={true}
						disableAutoscroll={true}
					/>
				}
				{this.props.store.CanManage && !isEdit && !uistate.isDevice && !this.props.store.isNews &&
					<AddButton Title="Добавить раздел" onClick={() => this.props.store.Glossary.addGroup()} />
				}
			</div>
		)
	}
}
PageContentListBlock = observer(PageContentListBlock);

class GroupNameBlock extends Component {
	/** API запрос изменения названия раздела */
	onConfirm() {
		if (this.props.Group.Id !== -1)
			ContentApi.saveGroup(this.props.Group.getData(), () => { this.props.getData(); })
		else this.props.addGroupToList();
	}

	render() {
		return(
			<FormModal
				ClassName="ContentGroup"
				Title={this.props.Group.Id === -1 ? "Добавить раздел" : "Изменить название раздела"}
				onSubmit={this.onConfirm.bind(this)}
				onClose={this.props.onClose}
			>
				<TextInput
					Id="Name"
					Title="Название раздела"
					Required={true}
					Value={this.props.Group.Name}
					onChange={(value, id) => this.props.Group.collect(id,value)}
				/>
			</FormModal>
		)
	}
}
GroupNameBlock = observer(GroupNameBlock);

class PageContentListItem extends Component {
	/** Открыть статью из списка */
	openArticle(event) {
		event.preventDefault();
		this.props.store.Glossary.setArticle(parseInt(event.currentTarget.dataset.id))
	}

	/**
	 * API запрос «ChangeOrderContent» для изменения порядка статей в группе
	 * @param {object} sortParams параметры сортировочной функции
	 */
	changeOrderPages(sortParams) {
		ContentApi.saveGroup(this.props.store.Glossary.changeOrderPages(this.props.GroupId, sortParams), () => {
			this.props.getData(); 
		});
	}

	render() {
		var isEdit = this.props.store.Glossary.Article && this.props.store.Glossary.Article.EditMode,
			SortableItem = SortableElement(({value, sortIndex}) => {
				var active = this.props.store.Glossary.Article && this.props.store.Glossary.Article.Id === value.Id ? "active " : "";
				
				return(
					<a key={value.Id} href='/' onClick={this.openArticle.bind(this)} 
						data-id={value.Id} index={sortIndex}
						className={"SortableItem " + active + (!value.Active ? "notactive" : value.Id === -1 ? "new" : "")}
					>
						{this.props.store.CanManage && !this.props.store.isNews && !uistate.IsMobile && !isEdit && <DragHandle />}
							{value.Name}
					</a>
				)
			}),
			SortableList = SortableContainer(({items}) => {
				return (
					<div className="SortableList">{items.map((value, index) => (
						<SortableItem key={"ag" + index} index={index} value={value} sortIndex={index} />
					))}</div>
				);
			});
		
		return(
			<div className='pages'>
				<SortableList 
					items={this.props.Pages} 
					onSortEnd={(sortParams) => this.changeOrderPages(sortParams)}
					useDragHandle   
					helperClass="SortableHelper"
					axis="xy"
					lockToContainerEdges={true}
					disableAutoscroll={true}
				/>
			</div>
		)
	}
}
PageContentListItem = observer(PageContentListItem);

class ArticleBlock extends Component {
	/** API запрос «ChangeStateContent» на изменение режима видимости статьи (не админу) */
	toggleArticle () {
		ContentApi.toggle(this.props.Article.Id, !this.props.Article.Active, () => {
			this.props.getData();
		});
	}

	/** API запрос «RemoveContent» на удаление статьи */
	removeArticle() { 
		var text = <span>Вы действительно хотите удалить статью <b key="b1">«{this.props.Article.Name}»</b>?</span>;

		confirmState.openConfirm(text, () => {
			ContentApi.remove(this.props.Article.Id, () => { this.props.getData(); });
		});
	}

	/** Включение/выключение режима редактирования статьи */
	toggleEditMode() {
		if (this.props.Article.EditMode && this.props.Article.Id === -1)
			this.props.clearEmptyArticle();
		else
			this.props.Article.EditMode = !this.props.Article.EditMode;
	}

	/** API запрос «SaveContent» на сохранение изменений статьи */
	handleSubmit (event) {
		event.preventDefault();

		this.props.Article.ButtonLoading = true;

		ContentApi.save(this.props.Article.getData(), (data) => {
			this.props.Article.ButtonLoading = false;
			this.props.Article.ErrorCode = data.Success ? "" : data.ErrorCode;

			if (data.Success) {
				this.props.getData(data.Id);
				this.props.Article.EditMode = false;
			}
		});
	}

	render() {
		var article = this.props.Article;

		if (_.isUndefined(article))
			return(<div className='article'><h4>Статьи не существует</h4></div>)

		return(
			<form className='article form' onSubmit={this.handleSubmit.bind(this)}>
				<div className="head">
					{!article.EditMode ? <h4>{article.Name}</h4> :
						<TextInput
							Id="Name"
							Title="Название статьи"
							Value={article.Name}
							Required={true}
							onChange={(value, id) => article.collect(id, value)}
						/>
					}
					{!uistate.IsMobile && !article.EditMode &&
						<div className='actions'>
							{this.props.CanManage &&
								<>
									<EditIconButton onClick={this.toggleEditMode.bind(this)} />
									<VisibilityIconButton Active={article.Active}
										onClick={this.toggleArticle.bind(this)} />
									<RemoveIconButton onClick={this.removeArticle.bind(this)} />
								</>
							}
							{article.CanPrint && article.IsDocs &&
								<ReactToPrint
									trigger={() => <PrintIconButton Title="Распечатать документ" />}
									content={() => this.componentRef}
								/>
							}
						</div>
					}
					{article.EditMode && 
						<div>
							{article.IsDocs &&
								<CheckFilter
									Id="CanPrint"
									Title="Можно распечатать"
									Value={article.CanPrint}
									RowClass="nomargin"
									onChange={(value, id) => article.collect(id, value)}
								/>
							}
							{article.IsNews &&
								<CheckFilter
									Id="Push"
									Title="Отправить уведомление"
									Value={article.Push}
									onChange={(value, id) => article.collect(id, value)}
								/>
							}
						</div>
					}
				</div>
				{article.EditMode &&
					<div className='settings'>
						<Selectize
							Id="FilialsId"
							Title="Доступно филиалам"
							Value={article.FilialsId}
							List={toSelectList(this.props.Filials)}
							Multi={true}
							onChange={(value, id) => article.collect(id, value)}
						/>
						{article.IsNews &&
							<Selectize
								Id="RolesId"
								Title="Достапно должностям"
								Value={article.RolesId}
								List={toSelectList(this.props.Roles)}
								Multi={true}
								onChange={(value, id) => article.collect(id, value)}
							/>
						}
						{article.IsStock &&
							<Selectize
								Id="BrandId"
								Title="Относится к бренду"
								Value={article.BrandId}
								List={toSelectList(this.props.Brands)}
								onChange={(value, id) => article.collect(id, value)}
							/>
						}
					</div>
				}
				{!article.EditMode &&
					<div className='credits'>
						<p>{article.IsNews ? "Новость" : "Последнее изменение"} от {formatDate(article.LastUpdate)}, {article.UserName}</p> :
						{this.props.CanManage &&
							<>
								<p>Доступно филиалам: {article.Filials === "" ? "Недоступно" : article.Filials}</p>
								{article.IsNews && <p>Доступно должностям: {article.Roles}</p>}
								{article.IsStock && article.BrandId > 0 && <p>Для бренда: {article.Brand}</p>}
							</>
						}
					</div>
				}
				<div className="body">
					{!article.EditMode ?
						<ComponentToPrint ref={el => (this.componentRef = el)} Text={article.Text} /> :
						<TextEditor
							Id="Text"
							Value={article.Text}
							Required={true}
							onChange={(value, id) => article.collect(id, value)}
						/>
					}
				</div>
				<InlineError ErrorCode={article.ErrorCode} />
				{article.EditMode && 
					<div className="buttons">
						<SubmitButton Title="Сохранить" Loading={article.ButtonLoading}  />
						<button type='button' className='secondary' onClick={this.toggleEditMode.bind(this)}>Отменить</button>
					</div>
				}
			</form>
		)
	}
}
ArticleBlock = observer(ArticleBlock)


class ComponentToPrint extends Component { render() { return (Parser(this.props.Text)); } }



export class ContentWidget extends Component {
	constructor(props) {
		super(props);

		this.getData();
	}

	/** API запрос на получение данных контента в разделе «Новости» */
	getData() {
		contentState.IsSendRequest = false;
		ContentApi.getList(94, (data) => { contentState.setContent(data, undefined, true); })
	}

	/** Переход на страницу «Новости» */
	handleSelect() {
		authUserState.DashboardId = 94;
		cookie.save("DashboardId", 94);
	}

	render() {
		return(<div className="widget" id="NewsWidget">
			<h4>Новости</h4>
			<NavLink to="/News" className="openPage" title="Перейти на страницу новостей"
				onClick={this.handleSelect.bind(this)}><i></i></NavLink>

			{contentState.IsSendRequest && !_.isUndefined(contentState.Glossary) && _.isEmpty(contentState.Glossary.AllPages) &&
				<p className="comment">У вас нет новостей</p>
			} 

			{contentState.IsSendRequest && !_.isUndefined(contentState.Glossary) && !_.isEmpty(contentState.Glossary.AllPages) &&
				_.map(contentState.Glossary.Pages[0].Pages, (item, i) => {
					return(<NewsItemWidget Item={item} Index={i} key={"n" + i} />);
				})
			} 
		</div>)
	}
}
ContentWidget = observer(ContentWidget);
class NewsItemWidget extends Component {
	/** Переход на страницу «Новости» на конкретную статью */
	onClick () { 
		authUserState.DashboardId = 94;
		cookie.save("DashboardId", 94);
		contentState.Glossary.setArticle(this.props.Item.Id);
	}

	render() {
		return(
			<div className="clearfix news">
				<NavLink to="/News" title={this.props.Item.Name} onClick={this.onClick.bind(this)}>
					{this.props.Item.Name}</NavLink>
				<p className="comment">{this.props.Item.UserName}, {formatDate(this.props.Item.LastUpdate)}</p>
			</div>
		)
	}
}
